type AnyFunction = (...args: any[]) => any;

export async function setTimeoutAsync<TFn extends AnyFunction>(cb: TFn, timeout: number): Promise<ReturnType<TFn>> {
    return new Promise<ReturnType<TFn>>((resolve, _reject) => {
        setTimeout(() => resolve(cb()), timeout);
    });
}
